module.exports = __webpack_public_path__ + "static/about-insta-8@2x-b0cfbc1ef32953cb36083d3f771a87ca.jpg";